export default __webpack_public_path__ + "static/friends-280bb304834a0db94e856ae93be3ffff.png";